exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text{\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.textIndic{\n  margin-left: 20px;\n  margin-bottom: 7px;\n}\n\n.map{\n  width: 100%;\n  height: 300px;\n}\n\n.mapContainer{\n  margin-top: 20px;\n  margin-bottom: 30px;\n}\n\nimg{\n  width: 100%;\n}\n\n.images-cabinet {\n  width: 80%;\n  margin:auto;\n  display: block;\n  padding-bottom: 30px;\n}\n\n.access-details {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/yoann/Perso/Pedicure-Podologue/src/app/cabinet/cabinet.component.css
// module id = ../../../../../src/app/cabinet/cabinet.component.css
// module chunks = 1